import type { BetterFeatureClientPlugin } from "@di-devs/better-feature/types";
import type { auth } from "../server/plugin";
import { createAuthCorePlugin } from "./auth-core/plugin";

export const authClient = () => {
	return {
		id: "auth",
		$InferServerPlugin: {} as ReturnType<typeof auth>,
		getAtoms: ($fetch: any) => {
			// Create subfeature plugin
			const authCorePlugin = createAuthCorePlugin($fetch);

			return {
				// Signals (prefixed with $)
				$loginSignal: authCorePlugin.signals.$loginSignal,
				$logoutSignal: authCorePlugin.signals.$logoutSignal,
				$getSessionSignal: authCorePlugin.signals.$getSessionSignal,

				// Queries (become hooks with "use" prefix)
				login: authCorePlugin.queries.login,
				logout: authCorePlugin.queries.logout,
				getSession: authCorePlugin.queries.getSession,

				// State atoms
				...authCorePlugin.atoms,
			};
		},
		getActions: ($fetch: any) => {
			const authCorePlugin = createAuthCorePlugin($fetch);

			return {
				// Actions are spread directly onto client
				...authCorePlugin.actions,
			};
		},
		atomListeners: [
			{
				signal: "$sessionSignal",
				matcher: (path: string) => path.startsWith("/auth"),
			},
		],
	} satisfies BetterFeatureClientPlugin;
};
